import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthGaurdService } from './auth-gaurd.service';
import { BannerConfig, CurrentBanner } from '../models/config/banner-config.model';

@Injectable({
    providedIn: 'root'
})
export class BannerConfigService {

    private host = environment.apiUrl + "banner";
    public loggedinUser: string = '';

    constructor(
        private http: HttpClient,
        private logger: LoggerService, 
        private authGaurdService: AuthGaurdService
    ) {
        this.loggedinUser = this.authGaurdService.loginUser();
    }

    public getCurrentBanner(salesChannel?: string, userRole?: string): Observable<CurrentBanner> {
        let url = this.host + '/current';
        const params: string[] = [];
        if (salesChannel) {
            params.push(`salesChannel=${encodeURIComponent(salesChannel)}`);
        }
        if (userRole) {
            params.push(`userRole=${encodeURIComponent(userRole)}`);
        }
        if (params.length > 0) {
            url += '?' + params.join('&');
        }
        return this.http.get<CurrentBanner>(url)
            .pipe(
                map((data: CurrentBanner) => {
                    return data;
                }), 
                catchError(error => {
                    this.logger.info('Error getting current banner: ', error);
                    return throwError('Error loading banner');
                })
            );
    }

    public getBannerConfig(): Observable<BannerConfig> {
        const url = this.host + '/config';
        return this.http.get<BannerConfig>(url)
            .pipe(
                map((data: BannerConfig) => {
                    return data;
                }), 
                catchError(error => {
                    this.logger.info('Error getting banner config: ', error);
                    return throwError('Error loading banner configuration');
                })
            );
    }

    public saveBannerConfig(config: BannerConfig): Observable<any> {
        const url = this.host + '/config';
        const formData = this.createFormData(config);
        return this.http.post<any>(url, formData)
            .pipe(
                map((data: any) => {
                    return data;
                }), 
                catchError(error => {
                    this.logger.info('Error saving banner config: ', error);
                    return throwError('Error saving banner configuration');
                })
            );
    }

    private createFormData(config: BannerConfig): FormData {
        const formData = new FormData();
        formData.append('message', config.message);
        formData.append('startTime', config.startTime);
        formData.append('endTime', config.endTime);
        formData.append('timezone', config.timezone);
        formData.append('isActive', config.isActive);
        // Add sales channel if provided
        if (config.salesChannel) {
            formData.append('salesChannel', config.salesChannel);
        }
        // Add blockAccess flag if provided
        if (config.blockAccess) {
            formData.append('blockAccess', config.blockAccess);
        }
        const currentUser = this.authGaurdService.loginUser();
        formData.append('currentUser', currentUser || '');
        return formData;
    }
}
